import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'particle-expert-services-edit-hyperlink-cell-viewer',
  templateUrl: './edit-expert-services-hyperlink-cell-viewer.component.html',
  styleUrls: ['./edit-expert-services-hyperlink-cell-viewer.component.scss']
})
export class EditExpertServicesHyperlinkCellViewerComponent implements OnInit, CellComponent {
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  icon: string;
  disabled: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  onEditClick(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }

  onHyperLinkClick() {
    if ((this.item && !this.item.isReadOnly) ||
      (this.fieldDefinition && this.fieldDefinition.metaData && this.fieldDefinition.metaData.CanCellUnlock === 'true')) {
      this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});
    }
  }

}
